import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "Dictation" */ "./lazyIndex"), {
    name: "Dictation",
});

export const lazyToggleDictation: LazyImport<typeof lazyIndex.toggleDictation, typeof lazyModule> = new LazyImport(lazyModule, m => m.toggleDictation);
export { getDictationStore } from "./store/store";
export { DictationButtonStateEnum } from "./store/schema/DictationButtonStateEnum";
export { DictationViewState } from "./store/schema/DictationViewState";
export type { DictationUITelemetry } from "./components/DictationUITelemetry";
export const DictationHelpPane: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.DictationHelpPane);
